import { GroupsTableActions } from "./GroupsTableActions";

export const getGroupsTableColumns = () => {
  return [
    {
      header: "ID",
      id: "ID",
      accessorKey: "id",
      size: 60,
      cell: ({ row }) => (
        <span className="tw:font-bold">{row.original?.id}</span>
      ),
    },
    {
      header: "Name",
      id: "Name",
      accessorKey: "name",
    },
    {
      header: <div></div>,
      id: "Actions",
      accessorKey: "actions",
      enableSorting: false,
      enableResizing: false,
      size: 60,
      meta: {
        isDisplay: true,
      },
      cell: ({ row }) => <GroupsTableActions original={row.original} />,
    },
  ];
};
